import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import SectionContainer from 'components/Containers/SectionContainer';
import { commafy } from 'helpers/number';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import './PersonalLoanPrequalHighCcDebt.scss';

const CreditReportedBalanceCard = ({ creditInfo, className }) => {
  return (
    <FlexContainer className={className}>
      <div className="text-10 bold fontGray400 lineHeight-1-6 text-center bold">
        {'REPORTED CREDIT BALANCES'}
      </div>
      <div className="text-24 fontGreen400 text-center lineHeight-1-33 bold margT4">
        ${commafy(creditInfo?.debtAnalysis?.creditCardDebt?.totalDebt)}
      </div>
    </FlexContainer>
  );
};

export const PersonalLoanPrequalHighCcDebtView = ({ ...props }) => {
  return (
    <SectionContainer className="personalLoanHighCcDebtContainer">
      <Row>
        <FlexContainer className="m-flex-column justify-between margT12">
          <CreditReportedBalanceCard
            creditInfo={props.creditInfo}
            className="reportedCreditBalance grayShadow16 border-rad8px flex-column justify-center t-hide padLR16"
          />

          <FlexContainer className="flex-column m-justify-center m-padLR0 padL24 padR32">
            <div className="text-28 t-text-24 fontGray400 lineHeight-1-43 bold t-text-center">
              {'Pay this down with a personal loan'}
            </div>
            <CreditReportedBalanceCard
              creditInfo={props.creditInfo}
              className={
                'grayShadow16 border-rad8px flex-column padTB16 padLR16 justify-center m-margT24 d-hide'
              }
            />
            <div className="text-16 fontGray400 lineHeight-1-5 notBold margT8 t-text-center m-margT24">
              <p>
                See if you're pre-qualified instantly with no impact to your
                credit score
              </p>
            </div>
          </FlexContainer>

          <FlexContainer className="margT24 m-margT0">
            <Button
              mrphType="primary"
              onClick={() => props.onClickPrequal()}
              className="border-rad4px preQualifyButton"
            >
              <FlexContainer className="justify-center align-items-center">
                <Label type="Subtitle-2" color="primary_cta_text_light">
                  {'Check Pre-Qualification'}
                </Label>
              </FlexContainer>
            </Button>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};
